import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  ViewContainerRef,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';
import { OnDestroy } from '@angular/core';

import { TabComponent } from './tab.component';
// import { DynamicTabsDirective } from './dynamic-tabs.directive';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
// import { BreadcrumbService } from '../SmartReporter/sm-Services/breadcrumb.service';
// import 'rxjs/add/operator/toPromise';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserserviceService } from '../services/userservice/userservice.service';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { ApiserviceService } from '../Service/apiservice.service';
import { BreadcrumbService } from '../services/sm-Services/breadcrumb.service';
import { StandardUIService } from '../services/standardui-service/standardui-service';

@Component({
  selector: 'my-tabs',

  template: `
  <!-- div>
  <app-sm-breadcrumb (componentSelection)="openCategory($event)"></app-sm-breadcrumb>
    </div -->


    <div class="d-flex">
    <ul class="nav nav-tabs custom-tabs">
      <!--li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
        <a href="javascript:;">{{tab.title}}</a>
      </li-->



      <!-- dynamic tabs smartreporter(tab);-->
      <li  *ngFor="let tab of dynamicTabs" (click)="selectTab(tab)" [class.active]="tab.active">
    <a #tabLink attr.data-obj-personid="{{tab.dataContext.personid}}" attr.data-obj-hide="{{tab.dataContext.hide}}" attr.data-obj-entity="{{tab.dataContext.entityName}}" attr.data-obj-title="{{tab.title}}" attr.data-obj-id="{{tab.dataContext.id}}" attr.data-obj-type="{{tab.dataContext.type}}" href="javascript:;"  style="cursor: pointer;" class="print-hide"    ><img [src]="tab.dataContext.src" *ngIf="tab.dataContext.src" class="tabActiveImg" />&nbsp;<span >{{tab.title}}</span> <span class="tab-close" *ngIf="tab.isCloseable" (click)="closeTab(tab);checkcloseTab(tab)">  <i attr.data-closebutton-id="{{tab.title}}-closebutton" class="fa-solid fa-xmark"></i></span></a>
  </li>
    </ul>

<div ngbDropdown class="tab-option ms-1 position-relative" style="cursor: pointer;" >



<!-- <mat-form-field>
  <mat-select [(value)]="selectedOption" (onOpen)="onChange($event.value)">
    <input type="text" placeholder="Search tabs" [(ngModel)]="searchTerm" class="form-control  " style="min-height:34px">
    <ng-container *ngFor="let tab of filterTabs()">
      <mat-option *ngIf="getattribute(tab.dataContext.id)!=='hide'"  [value]="tab.title" (click)="navigatetotab(tab)">
        <span class="d-flex justify-content-between">
          <span>{{ tab.title }}</span>
          <span *ngIf="tab.isCloseable" (click)="closeTab(tab)"><i class="fa-solid fa-xmark"></i></span>
        </span>
      </mat-option>
    </ng-container>
  </mat-select>
</mat-form-field> -->


<div  ngbDropdownToggle class="search-box print-hide">
<!-- <i class="fa-solid fa-chevron-down form-tab" [(ngModel)]="searchTerm" ></i> -->
<button type="button" class="form-tab btn-icon" (click)="toggleDropdown()" name="search term" >
  <i class="fa-solid fa-chevron-down"></i>
</button>

        <div ngbDropdownMenu class="dropdown-menu dropdownn tab-dbs dropdown-menu-right1" >
        <input type="text" style="margin-bottom: 10px;min-height: 34px;padding-left: 28px;border: none;border-bottom: solid 1px #c3c3c3;border-radius: 0;" placeholder="Search tabs"  [(ngModel)]="searchTerm" class="form-control" (click)="$event.stopPropagation()" name="searchTerm">
        <img src="../../assets/images/search-black.svg" height="14" style="position:absolute; top:20px; left:15px;opacity:.8">
        <ng-container *ngFor="let tab of filterTabs()">
          <a *ngIf="getattribute(tab.dataContext.id)!=='hide'" [ngClass]="{'tab-active':checkifactive(tab.dataContext.id)}" (click)="navigatetotab(tab)" >
          <span class="d-flex justify-content-between">
          <span>{{ tab.title }}</span>
          <span *ngIf="tab.isCloseable"  (click)="closeTab(tab)"><i class="fa-solid fa-xmark"></i></span>
        </span></a>
          </ng-container>
          <ng-container >
          <hr>
          <span ngbDropdownItem class="d-flex justify-content-center" (click)="closealltabs()">Close all tabs</span>
          </ng-container>
        </div>
      </div>




</div>
    </div>




  <ng-content></ng-content>
  <ng-template dynamic-tabs #container></ng-template>
  <ng-template #HomeTemplate let-componentContext="inputDataContext">
    <app-home></app-home>
  </ng-template>




   <!-- session expired -->

  <ng-template #SessionExpired let-c="close" let-d="dismiss">
      <div class="modal-header">
          <h3 class="modal-title font-weight-bold">Session Expired</h3>
          <button type="button" [disabled]="loading" class="close" (click)="d('Cross click')">&times;</button>
      </div>
      <div class="modal-body">
          <div class="expired">
              Session expired! Redirecting to Login page.
          </div>

      </div>
      <div class="modal-footer">
          <div *ngIf='sessiontimeout != 0'>
  <!--             <button type="button" class="btn btn-secondary" [disabled]="loading"  (click)="c('Close click')">Close</button> -->
  <!--             <button type="button" class="btn btn-danger" (click)="logout()">Logout</button> -->
          </div>
      </div>
  </ng-template>
`,
  styles: [
    `
    .tab-close {
      color: #fffff;
      text-align: right;
      cursor: pointer;
    }

    input::placeholder {
    color: #767676; font-weight:normal
    }

    .tabActiveImg
    {

      height: 12px;
    }

    .active .tabActiveImg {
      filter: brightness(0) invert(1) !important;
    }

    .tab-active{
      background-color:#e5e5e5;
      border-radius:4px
    }
  //   .tab-active:hover {
  //     background-color: #E0E8EE;
  //     color: blue;
  // }

  hr
  {
    background-color:#D9D9D9;
    margin-bottom:6px;
  }
  `
  ]
})
export class TabsComponent implements AfterContentInit, OnDestroy {


  dynamicTabs: TabComponent[] = [];
  @ViewChild("SessionExpired") public SessionExpired;
  @ViewChild('tabLink', { static: false }) tabLink: ElementRef;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  /*
    Alternative approach of using an anchor directive
    would be to simply get hold of a template variable
    as follows
  */
  @ViewChild('container', { read: ViewContainerRef }) dynamicTabPlaceholder;
  @Output() dynamicTabClose = new EventEmitter<any>();
  @Output() tabSelect = new EventEmitter<any>();
  @ViewChild('HomeTemplate') HomeTemplate;
  // @Output() componentSelection = new EventEmitter<any>();
  @Output() componentSelection = new EventEmitter<any>();
  @Output() stylingtabs = new EventEmitter<any>();

  tab_title: any;
  constructor(private standardService:StandardUIService,private _componentFactoryResolver: ComponentFactoryResolver, private breadcumbservice: BreadcrumbService, private modalService: NgbModal, private authService: MsalService, private userService: UserserviceService, private agentscriptservice: AgentscriptService_updated, private kbs: ApiserviceService
  ) {
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')
  }


  // threedots()
  // {
  //   console.log("three dots")
  //   $( ".custom-tabs li:not([style*='display: none'])" ).each(function( index ) {
  //     console.log( index + ": " + $( this ).find('a').attr('data-obj-id') );
  //   });
  // }

  // contentChildren are set
  ngAfterContentInit() {
    // get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    // if there is no active tab set, activate the first
    // if (activeTabs.length === 0) {
    //     this.selectTab(this.tabs.first);
    // }
  }

  checkclosed: boolean = true;
  breadcrumbtitle = ''
  breadcrumbopentab: boolean = false;
  closetabarray: any = [];
  noofelements: number = 0;
  checktab: any;


  openCategory(data: any) {
    console.log(data)

    if (data.link) {
      //     console.log("Tab clickable")
      //     console.log(data)
      //   console.log(data.link)
      //   data=data.title;
      this.tabs.toArray().forEach(tab => (tab.active = false));
      // this.tabs.toArray().forEach(tab => // console.log(tab));
      this.dynamicTabs.forEach(tab => (tab.active = false));
      // this.dynamicTabs.forEach(tab => // console.log(tab));

      this.checkclosed = true;

      this.breadcrumbtitle = data.title;
      this.breadcrumbopentab = true;
      // console.log(this.breadcrumbtitle)
      // console.log(data)
      // console.log("in if loop");
      for (let i = 0; i < this.dynamicTabs.length; i++) {
        // console.log(this.dynamicTabs[i].title)
        if (this.dynamicTabs[i].title === this.breadcrumbtitle) {
          // alert('240')
          this.selectTab(this.dynamicTabs[i])
          this.checkclosed = false;
          if (data.title == 'Smart Reporter') {
            this.componentSelection.emit(data)
          }
          break;
        }
      }
      if (data.title == 'home' && this.checkclosed) {
        this.breadcumbservice.add('home', 0, 'Home', true)
        this.openTab("Home", this.HomeTemplate, { id: 'home', name: 'Home', type: 'home' }, true, [...this.breadcumbservice.breadcrumb])
        this.emittabSelect(data)
      }

      else if (this.checkclosed) {
        // for (let i = 0; i < this.closetabarray.length; i++) {
        for (let i = this.closetabarray.length - 1; i >= 0; i--) {
          if (this.breadcrumbtitle === this.closetabarray[i].title) {
            this.breadcrumbopentab = false;
            this.checkclosed = false;
            this.openTab(this.closetabarray[i].title, this.closetabarray[i].template, this.closetabarray[i].dataContext, true, this.closetabarray[i].breadcrumbpath)
          }
          if (this.closetabarray[i].title == 'Smart Reporter')
            this.stylingtabs.emit('open')
          return false;
        }
      }
    }

  }
  emittabSelect(string: any) {
    console.log("String")
    this.componentSelection.emit(string)
  }
  authtoken;
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.userService.logout();
    this.authService.logout();
    //this.
  }
  // smartreporter(tab: TabComponent) {
  //   let tabstyling = 0

  //   if (tab.title == 'Smart Reporter') {

  //     switch (1) {
  //       case $("#mycatt").length:
  //         tabstyling = 0;
  //         break;

  //       case $("#myfavv").length:
  //         tabstyling = 1;
  //         break;

  //       case $("#myrcvv").length:
  //         tabstyling = 2;
  //         break;

  //       case $("#mywtll").length:
  //         tabstyling = 3;
  //         break;
  //     }

  //     console.log(tabstyling)

  //     this.stylingtabs.emit(tabstyling)

  //     // this.apiService.cat_table = true;
  //     // this.apiService.fav = false;
  //     // this.apiService.wtl = false;
  //     // this.apiService.rcv = false;


  //     // let array=({id: 'sm-smartreporter', name: 'Smart Reporter',type:'sm-smartreporter'})
  //     //   let array:{id:string,name:any,type:any}[]=[{"id":'Smart Reporter',"name":'My Categories',"type":'cat'}]

  //   } else {
  //     this.stylingtabs.emit(tab.dataContext.type);
  //   }
  //   console.log("tabsssssssssss", tab, this.dynamicTabs)
  // }

  collapseSmartReporterDropdown: boolean = true;
  //tabcomponentRef: any;
  checkifactive(id: any) {
    // console.log( $("[data-obj-id='" + id+ "']").parent().hasClass('active'))
    return $("[data-obj-id='" + id + "']").parent().hasClass('active');
    // return $("[data-obj-id='" + id+ "']").attr('data-obj-hide')
  }
  getattribute(id: any) {
    // console.log($("[data-obj-id='" + id+ "']").attr('data-obj-hide'));
    return $("[data-obj-id='" + id + "']").attr('data-obj-hide')
  }

  openTab(title: string, template, data, isCloseable = false, breadcrumbpath: any) {

    console.log(data)

    // console.log(this.dynamicTabs)

    if (!(typeof data.id == 'number') && data.id != null) {
      if (data.id.includes('incident-new')) {
        // "incident-newconfiguredNewSR1
        console.log("tab should be hidden is " + data.id.slice(12, data.id.length))
        $("[data-obj-id='" + data.id.slice(12, data.id.length) + "']").parent().hide();
        // data.hide="hide";
        console.log(this.dynamicTabs)
        console.log('incident-new' + data.id.slice(12, data.id.length))
        // var tabb=this.dynamicTabs.filter((x:any)=>x.dataContext.id==(data.id.slice(12,data.id.length)))
        $("[data-obj-id='" + data.id.slice(12, data.id.length) + "']").attr('data-obj-hide', 'hide')

        // tabb.dataContext.hide='';
        // console.log(tabb)
        // console.log(tabb[0])
        // tabb[0].dataContext.hide='hide'
      }
      else if (data.id.includes('configuredNewSR')) {
        // configuredNewSR4
        console.log(data.id)

        var tabb = this.dynamicTabs.filter((x: any) => !(typeof x.dataContext.id == 'number') && x.dataContext.id.includes(data.id))
        // console.log(tabb)
        if (tabb)
          $("[data-obj-id='" + data.id + "']").attr('data-obj-hide', 'hide')
      }

    }

    // get a component factory for our TabComponent
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
      TabComponent
    );

    Object.keys(sessionStorage).forEach(element => {
      // console.log(element.match("idtoken"));
      if (element.match("idtoken")) {
        this.authtoken = element

      }

    });
    if (this.authtoken) {
      var token = JSON.parse(sessionStorage.getItem(this.authtoken)).secret;
      token = token.split(".")[1];
      token = atob(token);
      var json = JSON.parse(token);
      var exp = json.exp * 1000;
      var current = Date.now();
      console.log('exp', exp)

      if (exp < current) {

        this.modalService.open(this.SessionExpired);
        setTimeout(() => {
          this.logout();
        }, 1000)

      }
    }
    // else{
    //   //alert((exp < current))
    // }



    // var token  = sessionStorage.getItem("msal.idtoken");
    // if(token)
    // {
    //         token = token.split(".")[1];
    //         token = atob(token);
    //         var json = JSON.parse(token);
    //         var exp = json.exp * 1000;
    //         var current =  Date.now();


    // // console.log('exp',exp);
    // // console.log('current',current);

    // // console.log('token on load',token);

    //     if(exp < current)
    //     {
    //         this.authService.acquireTokenSilent([environment.silentAPI],this.authService.authority,this.authService.getUser()).then(response => {
    //             // get access token from response
    //             // response.accessToken

    //             sessionStorage.setItem('msal.idtoken',response);
    //         }).catch(error=>{
    //             // console.log('error in getting silent token',error);
    //             sessionStorage.clear();
    //             this.authService.loginRedirect();
    //         });
    //    }

    // }
    // fetch the view container reference from our anchor directive
    // const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;

    // alternatively...
    let viewContainerRef = this.dynamicTabPlaceholder;

    // create a component instance
    var componentRef = viewContainerRef.createComponent(componentFactory);
    //this.tabcomponentRef = componentRef;
    // set the according properties on our component instance
    const instance: TabComponent = componentRef.instance as TabComponent;
    instance.title = title;
    instance.isCloseable = isCloseable;
    instance.dataContext = data;
    if (instance.dataContext.id == "home") {
      instance.isCloseable = false;
    }
    instance.template = template;
    if (instance.title == 'Search') {
      instance.isCloseable = false;
      console.log(instance);
      // this.selectTab(instance);

    }

    console.log('instance', instance)

    if (instance.dataContext.id == 'sm-smartreporter') {
      this.collapseSmartReporterDropdown = false;
    }
    // console.log(this.dynamicTabs.length)
    // if (this.dynamicTabs.length >= 1 && instance.dataContext.id == 'home') {
    //   console.log("okok")
    //   console.log(this.dynamicTabs)

    //   $("[data-obj-id='" + 'home' + "']").parent().trigger('click')
    //   // data-obj-id="home"
    //   // this.selectTab(instance)
    //   return;
    //   //this.selectTab(this.dynamicTabs[0]);
    // }
    // else {
    instance.breadcrumbpath = breadcrumbpath.splice(0, this.breadcumbservice.index + 1);
    this.breadcumbservice.test = instance.breadcrumbpath.length;
    this.noofelements = instance.breadcrumbpath.length;

    console.log(data)
    if (this.dynamicTabs.length > 0) {
      for (let i = 0; i < this.dynamicTabs.length; i++) {
        console.log(this.dynamicTabs[i])
        //console.log(this.dynamicTabs[i])   !this.dynamicTabs[i].dataContext.hasOwnProperty('newSr')
        if (this.dynamicTabs[i].dataContext.id === data.id) {

          if (!this.dynamicTabs[i].dataContext.hasOwnProperty('newSr') && !data.name == this.dynamicTabs[i].dataContext.name) {
            console.log("it dont have newsr")
            // this.closeTab(this.dynamicTabs[i]);
          }
          else {
            this.closeTab(this.dynamicTabs[i]);

          }
          // remember the dynamic component for rendering the
          // tab navigation headers
          //this.dynamicTabs[i] = componentRef.instance as TabComponent;
          // set it active
          //this.selectTab(this.dynamicTabs[i]);
          //return false;
        }
      }
    }
    // remember the dynamic component for rendering the
    // tab navigation headers

    // }
    // console.log(instance)
    // breadcrumb
    this.dynamicTabs.push(componentRef.instance as TabComponent);
    // console.log(componentRef.instance)

    // set it active
    // console.log("Select tab")


    console.log(this.dynamicTabs[this.dynamicTabs.length - 1])
    this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);

  }

  isDropdownOpen: boolean = false;
  toggleDropdown() {
    console.log(this.isDropdownOpen)
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectedOption: string = ""; // Make sure it's initialized properly
  changeTab(tab: any) {
    this.kbs.link = [];
    this.kbs.message = [];
    // Your logic to change the active tab

    // Set selectedOption based on the newly selected tab
    this.selectedOption = tab.title;
  }
  navigatetotab(e: any) {
    console.log(e.dataContext.id);
    console.log(this.dynamicTabs)
    $("[data-obj-id='" + e.dataContext.id + "']").parent().trigger('click');
  }

  searchTerm: any = '';
  filterTabs(): any[] {
    const filterValue = this.searchTerm.toLowerCase();
    return this.dynamicTabs.filter(tab => {
      if (typeof tab.title === 'string') {
        return tab.title.toLowerCase().includes(filterValue.toLowerCase());
      } else {
        return tab.title === filterValue; // Only return true if the value matches exactly
      }
    });
  }

  scrollToTab(tabId: string): void {
    // console.log("in scroll" + tabId)
    const tabElement = document.querySelector(`[data-obj-id="${tabId}"]`);

    if (tabElement) {
      tabElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  selectTab(tab: TabComponent) {
    // deactivate all tabs
    console.log(tab);
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title');
    var modifyscript = this.agentscriptservice.fetchData(this.tab_title, 'modifyscript')
    console.log(modifyscript)
    if (modifyscript) {
      // alert("modified script")
      $('#modifyscript-' + tab.title).trigger('click')
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'modifyscript', false)

      // this.componentSelectionEmitter({ src: '../../assets/images/NewSRactive.svg', alt: 'New Service Request', text: 'New Service Request (SR)', selected: false, type: "configuredNewSR", id: "configuredNewSR", height: "24px" })
    }
    console.log(tab.dataContext.type)
    if (tab.dataContext.type == 'configuredNewSR') {
      // console.log('it is in configuredNewSR')
      // $('#loadMap-' + tab.title).trigger('click')
      var element = document.getElementById('loadMap-' + tab.title);
      if (element) {
        // Trigger the click event
        var event = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': true
        });
        element.dispatchEvent(event);
      }

      $('#loaddataInfo-' + tab.title).trigger('click')

      setTimeout(() => {
        $('#loadFavourites-' + tab.title).trigger('click')
      }, 500);

    }

    this.tabSelect.emit(tab);
    this.tabs.toArray().forEach(tab => (tab.active = false));
    this.dynamicTabs.forEach(tab => (tab.active = false));

    const activeTabs = this.tabs.filter(tab => tab.active);

    // activate the tab the user has clicked on.
    if (tab) {
      tab.active = true;
    }

    setTimeout(() => {
      //$(window).resize();
      this.scrollToTab(tab.dataContext.id)
    }, 500)
  }

  // selectTab(tab: TabComponent) {
  //   console.log('selected tab',tab);

  //   this.tab_title=$(".custom-tabs li.active").find("a").attr('data-obj-title');    
  //   console.log("in select tab"+this.tab_title);
  //   //$(".custom-tabs li.active").find("a").attr();
  //   //let linkid = $(".custom-tabs li.active").find("a").attr('data-obj-id');    
  //   var modifyscript= this.agentscriptservice.fetchData(this.tab_title,'modifyscript')
  //   console.log(modifyscript)
  //   if(modifyscript)
  //   {
  //     // alert("modified script")
  //     $('#modifyscript-' + tab.title).trigger('click')
  //     this.agentscriptservice.updateOrInsertArray(this.tab_title,'modifyscript',false)

  //     // this.componentSelectionEmitter({ src: '../../assets/images/NewSRactive.svg', alt: 'New Service Request', text: 'New Service Request (SR)', selected: false, type: "configuredNewSR", id: "configuredNewSR", height: "24px" })
  //   }
  //   console.log(tab.dataContext.type)
  //   if (tab.dataContext.type == 'configuredNewSR') {
  //     // console.log('it is in configuredNewSR')
  //     // $('#loadMap-' + tab.title).trigger('click')
  //     var element = document.getElementById('loadMap-' + tab.title);
  //     if (element) {
  //       // Trigger the click event
  //       var event = new MouseEvent('click', {
  //         'view': window,
  //         'bubbles': true,
  //         'cancelable': true
  //       });
  //       element.dispatchEvent(event);
  //     }

  //     $('#loaddataInfo-' + tab.title).trigger('click')

  //     setTimeout(() => {
  //       $('#loadFavourites-' + tab.title).trigger('click')
  //       }, 500);

  //   }

  //   console.log(tab)
  //   this.changeTab(tab);
  //   // mdc-list-item--selected mat-mdc-option-active
  //   // deactivate all tabs
  //   //   console.log("in select tabs");
  //   // console.log(tab)
  //   // console.log(tab.dataContext.id)

  //   setTimeout(() => {
  //     this.scrollToTab(tab.dataContext.id)
  //   }, 200)
  //   // if(tab.dataContext.type.includes("configuredNewSR"))
  //   // {
  //   //   console.log("It has it")
  //   //   this.breadcumbservice.idname = tab.dataContext.id
  //   // }


  //   this.checktab = tab;
  //   this.breadcumbservice.breadcrumbarray = tab.breadcrumbpath;
  //   this.breadcumbservice.length = tab.breadcrumbpath.length;

  //   this.tabSelect.emit(tab);

  //   this.tabs.toArray().forEach(tab => (tab.active = false));
  //   this.dynamicTabs.forEach(tab => (tab.active = false));

  //   const activeTabs = this.tabs.filter(tab => tab.active);

  //   // activate the tab the user has clicked on.
  //   if (tab) {
  //     tab.active = true;
  //   }
  //   this.breadcrumbopentab = false;

  //  setTimeout(()=>{

  //   $(window).resize();

  //  },200)
  //   // this.smartreporter(tab);
  // }


  checkcloseTab(tab: TabComponent) {
    console.log("in checkclosetab")
    if (this.dynamicTabs.length > 1) {
      for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
        console.log(this.dynamicTabs[i].dataContext.id)

        console.log(this.dynamicTabs[i])
        // this.dynamicTabs[i].dataContext.id!='home'
        //console.log(tab.dataContext);
        if (tab.dataContext.id.toString().includes('configuredNew') && tab.dataContext.tabid == this.dynamicTabs[i].dataContext.name) {
          // alert('normal tab')
          this.closeTab(this.dynamicTabs[i])
        }
        else if (tab.dataContext.id.toString().includes('incident') && tab.dataContext.name == this.dynamicTabs[i].dataContext.tabid) {
          // alert(tab) || tab.dataContext.tabid == this.dynamicTabs[i].dataContext.name
          // alert('incident tab')
          this.closeTab(this.dynamicTabs[i])
          // setTimeout(() => {
          //   this.closeTab(this.dynamicTabs[i]);
          // });
        }

      }
    }
    if (tab.dataContext.id == 'sm-smartreporter') {
      this.stylingtabs.emit('close')
    }
  }
  closealltabs() {
    console.log(this.dynamicTabs.length)
    if (this.dynamicTabs.length > 1) {
      for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
        console.log(this.dynamicTabs[i].dataContext.id)

        console.log(this.dynamicTabs[i])
        // this.dynamicTabs[i].dataContext.id!='home'
        if (this.dynamicTabs[i].dataContext.id != 'home') {
          setTimeout(() => {
            this.closeTab(this.dynamicTabs[i]);
          });
        }


      }
    }
  }

  // closetab_updated(tab: TabComponent)
  // {
  //   if (this.dynamicTabs.length > 1) {
  //     for (let i = this.dynamicTabs.length - 1; i >= 0; i--) {
  //       console.log(this.dynamicTabs[i].dataContext.id)

  //       console.log(this.dynamicTabs[i])
  //       // this.dynamicTabs[i].dataContext.id!='home'
  //       if ((tab.dataContext.name == this.dynamicTabs[i].dataContext.tabid) ) {
  //         // alert(tab) || tab.dataContext.tabid == this.dynamicTabs[i].dataContext.name
  //         this.closeTab(this.dynamicTabs[i])
  //         // setTimeout(() => {
  //         //   this.closeTab(this.dynamicTabs[i]);
  //         // });
  //       }
  //     }
  //   }
  // }

  closeTab(tab: TabComponent) {

    // if (this.agentscriptservice.fetchData(tab.title, 'submitandcontinue') != true) {
    //   this.standardService.clearlocalStorage('addressdetailscomponent', tab.title)
    //   this.standardService.clearlocalStorage('tabdata', tab.title)
    //   this.standardService.clearlocalStorage('servicepayload', tab.title)

    //   this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno == tab.title) > -1 ? this.agentscriptservice.AlldataArray.splice(this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno == tab.title), 1) : '';
    //   console.log(this.agentscriptservice.AlldataArray)
    // }

    

    console.log("In close tab")
    console.log(tab)
    // console.log(tab.dataContext.name)

    if (tab.dataContext.id == 'sm-smartreporter') {
      this.breadcumbservice.categorytab = true;
      this.breadcumbservice.mycategoryiestab = true;
      this.breadcumbservice.stylingtab = true;

      //   if(this.collapseSmartReporterDropdown)
      //  this.stylingtabs.emit('close')
    }
    this.collapseSmartReporterDropdown = true;
    // Store only minimal metadata to avoid retaining component trees
    this.closetabarray.push({
      title: tab.title,
      // do not persist template reference; it keeps closures alive
      dataContext: { ...tab.dataContext },
      breadcrumbpath: [...(tab.breadcrumbpath || [])]
    });
    if (this.closetabarray.length > 20) {
      this.closetabarray.splice(0, this.closetabarray.length - 20);
    }
    // console.log("lengtn of tabs is " + this.dynamicTabs.length)

    // if (this.dynamicTabs.length == 1 && this.dynamicTabs[0].dataContext.id == 'configuredSearch1') {
    if (this.dynamicTabs.length == 1) {
      console.log("okok")
    }

    else {
      for (let i = 0; i < this.dynamicTabs.length; i++) {
        if (this.dynamicTabs[i] === tab) {

          // console.log(this.dynamicTabs[i])
          // console.log(this.dynamicTabs[i].dataContext.id)
          // configuredSearch1
          // console.log(tab)
          // remove the tab from our array
          // if(this.dynamicTabs.length>1)
          this.dynamicTabs.splice(i, 1);

          // Scoped DOM & plugin cleanup for this tab id
          try {
            const tabId = tab.dataContext?.id;
            if (tabId) {
              const root = $(`.pane[data-tab-id='${tabId}']`);
              try { (root.find("[data-toggle='tooltip']") as any).tooltip('dispose'); } catch {}
              try { (root.find('.multichosen') as any).chosen('destroy'); } catch {}
              try { (root.find('input') as any).inputmask('remove'); } catch {}
              try {
                const sel = `#data-table${tabId}`;
                if (($ as any).fn && ($ as any).fn.dataTable && ($ as any).fn.dataTable.isDataTable && ($ as any).fn.dataTable.isDataTable(sel)) {
                  ((root.find(sel)) as any).DataTable().destroy(true);
                  root.find(sel).empty();
                }
              } catch {}
            }
          } catch {}

          // destroy our dynamically created component again
          // let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          let viewContainerRef = this.dynamicTabPlaceholder;
          viewContainerRef.remove(i);

          // set tab index to 1st one
          //this.selectTab(this.tabs.first);
          // if(this.dynamicTabs[this.dynamicTabs.length - 1]==undefined)
          // {
          //   console.log("tab is undefined")
          //   // this.selectTab(this.dynamicTabs[i]);
          // }
          // else{
          console.log("above select tab")
          //if (this.dynamicTabs.length) {
          // alert('735')
          this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
          //let linkid = $(".custom-tabs li.active").find("a").attr('data-obj-id');            
          $('[data-link-id]').removeClass('link-active');
          //alert(this.dynamicTabs[this.dynamicTabs.length - 1].dataContext.type);
          //setTimeout(()=>{

          $('[data-link-id="' + this.dynamicTabs[this.dynamicTabs.length - 1].dataContext.id + '"]').addClass('link-active');
          //},500)            
          //}
          // }
          // console.log(this.dynamicTabs[this.dynamicTabs.length - 1])
          break;
        }
      }
    }

    if (this.dynamicTabs.length <= 0) {
      this.dynamicTabClose.emit();
    }
    // Note: Avoid global event unbinding; each component should clean up its own listeners in ngOnDestroy
    // if (this.tabcomponentRef) {
    //   try { this.tabcomponentRef.destroy(); } catch {}
    //   this.tabcomponentRef = null;
    // }
  }

  ngOnDestroy(): void {
    try { this.dynamicTabs = []; } catch {}
    try { this.closetabarray = []; } catch {}
    //this.tabcomponentRef = null;
  }

  getTab(tabName) {
    return this.dynamicTabs.find(tab => tab.title == tabName);
    // return this.tabs.filter(tab => tab.title == tabName);
  }

  renameTab(oldtabName, newtabName) {
    if (this.dynamicTabs.find(tab => tab.title == oldtabName)) {
      return this.dynamicTabs.find(tab => tab.title == oldtabName).title = newtabName;
    } else {
    }
  }

  closeActiveTab() {    
    const activeTabs = this.dynamicTabs.filter(tab => tab.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }
  onChange(d) {
    alert()
  }
}
